import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { SaveUserStateToServerHelper } from "./Helper";
import { changeView } from "../actions/assessment";
import config from "../config/config-secret.json";
import * as moment from "moment";
import { toast } from "react-toast";

import { Translate } from "react-redux-i18n";
import Button from "./ui/Buttons/Button";

const validEmailRegex = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
);

export class JobApplicationForm1 extends Component {
  state = {
    applicant_name: this.props.full_name,
    applicant_email: this.props.email_address,
    applicant_address1: "",
    applicant_address2: "",
    applicant_city: "",
    applicant_state: "",
    applicant_zipcode: "",
    applicant_phone_number: "",
    applicant_second_phone_number: "",
    position_applied: this.props.job_applying,
    desired_salary: "",
    is_authorize_to_work_in_us: "",
    has_drivers_license: "",
    employers: [
      {
        employer: "",
        location: "",
        telephone: "",
        email: "",
        industry_type: "",
        job_title: "",
        date_from: "",
        date_to: "",
        supervisor_name: "",
        may_contact0: "",
        duties_description: "",
        reason_for_leaving: "",
      },
    ],
    references: [
      {
        name: "",
        organization: "",
        telephone: "",
        email_address: "",
        reference_type: "",
      },
    ],
    additional_information: "",
    english_skill: "",
    spanish_skill: "",
    skills_certifications: [
      {
        title: "",
        number_years_experience: "",
        ability_level: "",
      },
    ],
    errors: {
      applicant_name: "",
      applicant_email: "",
      applicant_city: "",
      applicant_state: "",
      applicant_phone_number: "",
      employers: [
        {
          employer: "",
        },
      ],
      references: [
        {
          email_address: "",
        },
      ],
    },
    isValidDateFrom: {},
    isValidDateTo: {},
  };

  retrieveJobApplication = async () => {
    const tester_id = this.props.assessment.tester_id;
    await axios
      .get(
        config.API_DOMAIN +
          `/v2/job_application/details/?tester_id=${tester_id}`,
      )
      .then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          const data = response.data;
          if (data.data.job_application) {
            this.setState({
              applicant_name: data.data.job_application.applicant_name,
              applicant_email: data.data.job_application.applicant_email,
              applicant_address1: data.data.job_application.applicant_address1,
              applicant_address2: data.data.job_application.applicant_address2,
              applicant_city: data.data.job_application.applicant_city,
              applicant_state: data.data.job_application.applicant_state,
              applicant_zipcode: data.data.job_application.applicant_zipcode,
              applicant_phone_number:
                data.data.job_application.applicant_phone_number,
              applicant_second_phone_number:
                data.data.job_application.applicant_second_phone_number,
              position_applied: data.data.job_application.position_applied,
              desired_salary: data.data.job_application.desired_salary,
              is_authorize_to_work_in_us: data.data.job_application
                .is_authorize_to_work_in_us
                ? data.data.job_application.is_authorize_to_work_in_us.toString()
                : "",
              has_drivers_license: data.data.job_application.has_drivers_license
                ? data.data.job_application.has_drivers_license.toString()
                : "",
              employers: data.data.employment_history.map((data, index) => {
                return {
                  employer: data.employer,
                  location: data.location,
                  telephone: data.telephone,
                  email: data.email,
                  industry_type: data.industry_type,
                  job_title: data.job_title,
                  date_from: moment(new Date(data.date_from)).format(
                    "YYYY-MM-DD",
                  ),
                  date_to: moment(new Date(data.date_to)).format("YYYY-MM-DD"),
                  supervisor_name: data.supervisor_name,
                  [`may_contact${index}`]: data.may_contact
                    ? data.may_contact.toString()
                    : "",
                  duties_description: data.duties_description,
                  reason_for_leaving: data.reason_for_leaving,
                };
              }),
              references: data.data.reference,
              additional_information:
                data.data.job_application.additional_information,
              english_skill: data.data.job_application.english_skill,
              spanish_skill: data.data.job_application.spanish_skill,
              skills_certifications: data.data.skill_certification,
              errors: {
                applicant_name: data.data.job_application.applicant_name
                  ? ""
                  : "This field is required.",
                applicant_email: data.data.job_application.applicant_email
                  ? ""
                  : "This field is required.",
                applicant_city: data.data.job_application.applicant_city
                  ? ""
                  : "This field is required.",
                applicant_state: data.data.job_application.applicant_state
                  ? ""
                  : "This field is required.",
                applicant_phone_number: data.data.job_application
                  .applicant_phone_number
                  ? ""
                  : "This field is required.",
                employers: data.data.employment_history.map((data) => {
                  return {
                    employer: data.employer ? "" : "This field is required.",
                  };
                }),
                references: data.data.reference.map((data) => {
                  return {
                    email_address:
                      (data.name ||
                        data.organization ||
                        data.telephone ||
                        data.reference_type) &&
                      !data.email_address
                        ? "This field is required."
                        : "",
                  };
                }),
              },
            });
          }
        }
      });
  };

  componentDidMount() {
    SaveUserStateToServerHelper(this.props.assessment);
    this.retrieveJobApplication();
  }

  handleInputChange = (event) => {
    // event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;
    // const value = target.type === 'checkbox' ? target.checked : target.value;
    // const name = target.name;

    switch (name) {
      case "applicant_name":
        errors.applicant_name = value === "" ? "This field is required." : "";
        break;
      case "applicant_email":
        errors.applicant_email = validEmailRegex.test(value)
          ? ""
          : "Email is not valid.";
        break;
      case "applicant_city":
        errors.applicant_city = value === "" ? "This field is required." : "";
        break;
      case "applicant_state":
        errors.applicant_state = value === "" ? "This field is required." : "";
        break;
      case "applicant_phone_number":
        errors.applicant_phone_number =
          value === "" ? "This field is required." : "";
        break;
      default:
        break;
    }

    this.setState({
      errors,
      [name]: value,
    });
  };

  handleMultipleFieldChange = (event, index, state) => {
    // event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;
    state[index][name] = value;

    switch (name) {
      case "employer":
        errors.employers[index].employer =
          value === "" ? "This field is required." : "";
        break;
      case "email_address":
        errors.references[index].email_address =
          value === "" ? "This field is required." : "";
        break;
      default:
        break;
    }

    this.setState({
      errors,
      state,
    });
  };

  addMoreEmployer = () => {
    let newEmployerField = {
      employer: "",
      location: "",
      telephone: "",
      email: "",
      industry_type: "",
      job_title: "",
      date_from: "",
      date_to: "",
      supervisor_name: "",
      may_contact: "",
      duties_description: "",
      reason_for_leaving: "",
    };
    let newEmployerErrorField = {
      employer: "",
    };

    if (this.state.employers.length <= 4) {
      this.setState({
        errors: {
          ...this.state.errors,
          employers: [...this.state.errors.employers, newEmployerErrorField],
        },
        employers: [...this.state.employers, newEmployerField],
      });
    }
  };

  removeEmployer = (index) => {
    let data = [...this.state.employers];
    let errorEmployer = [...this.state.errors.employers];
    errorEmployer.splice(index, 1);
    data.splice(index, 1);
    this.setState({
      errors: { ...this.state.errors, employers: errorEmployer },
      employers: data,
    });
  };

  addMoreReference = (event) => {
    event.preventDefault();
    let newReferenceFields = {
      name: "",
      organization: "",
      telephone: "",
      email_address: "",
      reference_type: "",
    };

    let newReferenceErrorField = {
      email_address: "",
    };

    if (this.state.references.length <= 2) {
      this.setState({
        errors: {
          ...this.state.errors,
          references: [...this.state.errors.references, newReferenceErrorField],
        },
        references: [...this.state.references, newReferenceFields],
      });
    }
  };

  removeReference = (index) => {
    let data = [...this.state.references];
    let errorReference = [...this.state.errors.references];
    errorReference.splice(index, 1);
    data.splice(index, 1);
    this.setState({
      errors: { ...this.state.errors, references: errorReference },
      references: data,
    });
  };

  addMoreSkillCertification = (event) => {
    event.preventDefault();
    let newSkillCertificationFields = {
      title: "",
      number_years_experience: "",
      ability_level: "",
    };

    if (this.state.skills_certifications.length <= 2) {
      this.setState({
        skills_certifications: [
          ...this.state.skills_certifications,
          newSkillCertificationFields,
        ],
      });
    }
  };

  removeSkillCertification = (index) => {
    let data = [...this.state.skills_certifications];
    data.splice(index, 1);
    this.setState({
      skills_certifications: data,
    });
  };

  validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
      // if we have an error string set valid to false
      (val) => {
        if (Array.isArray(val)) {
          val.map((item, index) => {
            if ("employer" in item) {
              item.employer.length > 0 && (valid = false);
            }
            if ("email_address" in item) {
              item.email_address.length > 0 && (valid = false);
            }
            // (item.employer.length  > 0 || item.references.length > 0) && (valid = false)
          });
        } else {
          val.length > 0 && (valid = false);
        }
      },
    );
    return valid;
  };

  validateDateFrom = (employers) => {
    let valid = [];
    let isValidDateFrom = {};
    employers.filter((employer, index) => {
      if (employer.date_from === "") {
        isValidDateFrom[`date_from${index}`] = "Invalid Date.";
        valid.push(false);
      } else {
        const selectedDateFrom = new Date(employer.date_from);
        const month = selectedDateFrom.getMonth() + 1;
        const day = selectedDateFrom.getDate();
        const fullyear = selectedDateFrom.getFullYear();
        if (
          month >= 1 &&
          month <= 12 &&
          day >= 1 &&
          day <= 31 &&
          fullyear >= 1900 &&
          fullyear <= 2050
        ) {
          valid.push(true);
        } else {
          isValidDateFrom[`date_from${index}`] = "Invalid Date.";
          valid.push(false);
        }
      }
    });
    this.setState({
      isValidDateFrom: isValidDateFrom,
    });
    return valid.every((element) => element === true);
  };

  validateDateTo = (employers) => {
    let valid = [];
    let isValidDateTo = {};
    employers.filter((employer, index) => {
      if (employer.date_to === "") {
        isValidDateTo[`date_to${index}`] = "Invalid Date.";
        valid.push(false);
      } else {
        const selectedDateTo = new Date(employer.date_to);
        const month = selectedDateTo.getMonth() + 1;
        const day = selectedDateTo.getDate();
        const fullyear = selectedDateTo.getFullYear();
        if (
          month >= 1 &&
          month <= 12 &&
          day >= 1 &&
          day <= 31 &&
          fullyear >= 1900 &&
          fullyear <= 2050
        ) {
          valid.push(true);
        } else {
          isValidDateTo[`date_to${index}`] = "Invalid Date.";
          valid.push(false);
        }
      }
    });
    this.setState({
      isValidDateTo: isValidDateTo,
    });
    return valid.every((element) => element === true);
  };

  saveJobApplicationForm1 = () => {
    toast.hideAll();
    const cleanEmployerFields = this.state.employers.filter(
      (employer, index) => {
        if (index > 0 && Object.values(employer).every((v) => v === "")) {
          return false;
        }
        return true;
      },
    );

    const cleanReferenceFields = this.state.references.filter(
      (reference, index) => {
        if (index > 0 && Object.values(reference).every((v) => v === "")) {
          return false;
        }
        return true;
      },
    );

    const cleanSkillCertificationFields =
      this.state.skills_certifications.filter((skill_certification, index) => {
        if (
          index > 0 &&
          Object.values(skill_certification).every((v) => v === "")
        ) {
          return false;
        }
        return true;
      });

    const isValidDateFromFields = this.validateDateFrom(cleanEmployerFields);
    const isValidDateToFields = this.validateDateTo(cleanEmployerFields);

    const applicant_name = this.state.applicant_name;
    const applicant_email = this.state.applicant_email;
    const applicant_address1 = this.state.applicant_address1;
    const applicant_address2 = this.state.applicant_address2;
    const applicant_city = this.state.applicant_city;
    const applicant_state = this.state.applicant_state;
    const applicant_zipcode = this.state.applicant_zipcode;
    const applicant_phone_number = this.state.applicant_phone_number;
    const applicant_second_phone_number =
      this.state.applicant_second_phone_number;
    const position_applied = this.state.position_applied;
    const desired_salary = this.state.desired_salary;
    const is_authorize_to_work_in_us = this.state.is_authorize_to_work_in_us;
    const has_drivers_license = this.state.has_drivers_license;
    const employers = cleanEmployerFields;
    const references = cleanReferenceFields;
    const additional_information = this.state.additional_information;
    const english_skill = this.state.english_skill;
    const spanish_skill = this.state.spanish_skill;
    const skills_certifications = cleanSkillCertificationFields;
    let errors = this.state.errors;

    errors.applicant_name =
      applicant_name === "" ? "This field is required." : "";
    errors.applicant_email = validEmailRegex.test(applicant_email)
      ? ""
      : "Email is not valid.";
    errors.applicant_city =
      applicant_city === "" ? "This field is required." : "";
    errors.applicant_state =
      applicant_state === "" ? "This field is required." : "";
    errors.applicant_phone_number =
      applicant_phone_number === "" ? "This field is required." : "";

    employers.map((employerField, index) => {
      errors.employers[index].employer =
        employerField.employer === "" ? "This field is required." : "";
    });
    console.log(references);
    references.map((referenceField, index) => {
      errors.references[index].email_address =
        (referenceField.name !== "" ||
          referenceField.organization !== "" ||
          referenceField.telephone !== "" ||
          referenceField.reference_type !== "") &&
        referenceField.email_address === ""
          ? "This field is required."
          : "";
    });

    this.setState({
      errors,
    });

    const tester_id = this.props.assessment.tester_id;

    if (
      this.validateForm(this.state.errors) &&
      isValidDateFromFields &&
      isValidDateToFields
    ) {
      axios
        .post(config.API_DOMAIN + "/v2/job_application/save_and_continue/", {
          tester_id: tester_id,
          applicant_name: applicant_name,
          applicant_email: applicant_email,
          applicant_address1: applicant_address1,
          applicant_address2: applicant_address2,
          applicant_city: applicant_city,
          applicant_state: applicant_state,
          applicant_zipcode: applicant_zipcode,
          applicant_phone_number: applicant_phone_number,
          applicant_second_phone_number: applicant_second_phone_number,
          position_applied: position_applied,
          desired_salary: desired_salary,
          is_authorize_to_work_in_us: is_authorize_to_work_in_us,
          has_drivers_license: has_drivers_license,
          employers: employers,
          references: references,
          additional_information: additional_information,
          english_skill: english_skill,
          spanish_skill: spanish_skill,
          skills_certifications: skills_certifications,
        })
        .then((res) => {
          console.log(res.data);
          document.querySelector("#initloader").style.display = "none";
        })
        .catch((error) => {
          document.querySelector("#initloader").style.display = "none";
          console.log(error);
          // alert("Something went wrong. Please contact administrator!");
        });

      this.props.show_job_application_form2();
    } else {
      toast.error("Please complete all required fields.", {
        backgroundColor: "#ed143d",
        color: "#ffffff",
      });
      console.error("Invalid Form");
    }
  };

  render() {
    const { errors, isValidDateFrom, isValidDateTo } = this.state;

    return (
      <div className="main container-fluid h-100 mt-lg-0 mt-xs-5">
        <div className="row test-container align-items-md-center">
          <div className="col-12">
            <div className="container">
              <div className="row  justify-content-center ">
                <div className="col-md-12">
                  <div className="test-info ">
                    {/* <ToastContainer position="top-center"/> */}

                    <h3 className="mt-4 mb-3 text-center">Application Form</h3>
                    {/* <h5><span className='error'>Please complete all required fields</span></h5> */}
                    <hr className="my-5" />

                    {/* Contact Information */}
                    <form className="form-custom">
                      <div className="row">
                        <div className="col-12">
                          <h5 className="text-black-50 font-weight-bold">
                            Contact Information
                          </h5>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                          <div className="form-label-group">
                            <input
                              type="text"
                              name="applicant_name"
                              id="applicant_name"
                              className="form-control"
                              placeholder="Name"
                              value={this.state.applicant_name}
                              onChange={this.handleInputChange}
                              required
                              autoFocus
                            />
                            <label htmlFor=" ">Name *</label>
                            {errors.applicant_name.length > 0 && (
                              <span className="error">
                                {errors.applicant_name}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                          <div className="form-label-group">
                            <input
                              type="email"
                              name="applicant_email"
                              id="applicant_email"
                              className="form-control"
                              placeholder="Email Address"
                              value={this.state.applicant_email}
                              onChange={this.handleInputChange}
                              required
                            />
                            <label htmlFor=" ">Email Address *</label>
                            {errors.applicant_email.length > 0 && (
                              <span className="error">
                                {errors.applicant_email}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-label-group">
                            <input
                              type="text"
                              name="applicant_address1"
                              id="applicant_address1"
                              className="form-control"
                              placeholder="Address 1"
                              value={this.state.applicant_address1}
                              onChange={this.handleInputChange}
                            />
                            <label htmlFor=" ">Address 1</label>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-label-group">
                            <input
                              type="text"
                              name="applicant_address2"
                              id="applicant_address2"
                              className="form-control"
                              placeholder="Address 2"
                              value={this.state.applicant_address2}
                              onChange={this.handleInputChange}
                            />
                            <label htmlFor=" ">Address 2</label>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-label-group">
                            <input
                              type="text"
                              name="applicant_city"
                              id="applicant_city"
                              className="form-control"
                              placeholder="City"
                              value={this.state.applicant_city}
                              onChange={this.handleInputChange}
                              required
                            />
                            <label htmlFor=" ">City *</label>
                            {errors.applicant_city.length > 0 && (
                              <span className="error">
                                {errors.applicant_city}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-label-group">
                            <input
                              type="text"
                              name="applicant_state"
                              id="applicant_state"
                              className="form-control"
                              placeholder="State"
                              value={this.state.applicant_state}
                              onChange={this.handleInputChange}
                              required
                            />
                            <label htmlFor=" ">State *</label>
                            {errors.applicant_state.length > 0 && (
                              <span className="error">
                                {errors.applicant_state}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-label-group">
                            <input
                              type="text"
                              name="applicant_zipcode"
                              id="applicant_zipcode"
                              className="form-control"
                              placeholder="ZIP Code"
                              value={this.state.applicant_zipcode}
                              onChange={this.handleInputChange}
                            />
                            <label htmlFor=" ">ZIP Code</label>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-label-group">
                            <input
                              type="text"
                              name="applicant_phone_number"
                              id="applicant_phone_number"
                              className="form-control"
                              placeholder="Phone"
                              value={this.state.applicant_phone_number}
                              onChange={this.handleInputChange}
                              required
                            />
                            <label htmlFor=" ">Phone *</label>
                            {errors.applicant_phone_number.length > 0 && (
                              <span className="error">
                                {errors.applicant_phone_number}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-label-group">
                            <input
                              type="text"
                              name="applicant_second_phone_number"
                              id="applicant_second_phone_number"
                              className="form-control"
                              placeholder="Second Phone"
                              value={this.state.applicant_second_phone_number}
                              onChange={this.handleInputChange}
                            />
                            <label htmlFor=" ">Second Phone</label>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-label-group">
                            <input
                              type="text"
                              name="position_applied"
                              id="position_applied"
                              className="form-control"
                              placeholder="Position Applied For"
                              value={this.state.position_applied}
                              onChange={this.handleInputChange}
                            />
                            <label htmlFor=" ">Position Applied For</label>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-label-group">
                            <input
                              type="text"
                              name="desired_salary"
                              id=""
                              className="form-control"
                              placeholder="Salary"
                              value={this.state.desired_salary}
                              onChange={this.handleInputChange}
                            />
                            <label htmlFor=" ">Desired Salary</label>
                          </div>
                        </div>
                        <div className="col-12 mb-3">
                          <label htmlFor=" " className="d-block text-black-50">
                            Are you authorized to work in the US?
                          </label>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="is_authorize_to_work_in_us"
                              id="is_authorize_to_work_in_us1"
                              checked={
                                this.state.is_authorize_to_work_in_us === "true"
                              }
                              value={true}
                              onChange={this.handleInputChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="is_authorize_to_work_in_us1"
                            >
                              YES
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="is_authorize_to_work_in_us"
                              id="is_authorize_to_work_in_us2"
                              checked={
                                this.state.is_authorize_to_work_in_us ===
                                "false"
                              }
                              value={false}
                              onChange={this.handleInputChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="is_authorize_to_work_in_us2"
                            >
                              NO
                            </label>
                          </div>
                        </div>
                        <div className="col-12 mb-3">
                          <label htmlFor=" " className="d-block text-black-50">
                            Do you have a valid driver's license?
                          </label>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="has_drivers_license"
                              id="has_drivers_license1"
                              checked={
                                this.state.has_drivers_license === "true"
                              }
                              value={true}
                              onChange={this.handleInputChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="has_drivers_license1"
                            >
                              YES
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="has_drivers_license"
                              id="has_drivers_license2"
                              checked={
                                this.state.has_drivers_license === "false"
                              }
                              value={false}
                              onChange={this.handleInputChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="has_drivers_license2"
                            >
                              NO
                            </label>
                          </div>
                        </div>
                      </div>
                    </form>

                    <hr className="my-5" />

                    {/* Employment History */}
                    <form className="form-custom">
                      <div className="row">
                        <div className="col-12">
                          <h5 className="text-black-50 font-weight-bold">
                            Employment History
                          </h5>
                          <p className="text-left">
                            Please list your last 5 employers, assignments, or
                            volunteer activities, starting with the most recent.
                            Incomplete information could disqualify you from
                            further consideration.
                          </p>
                        </div>
                      </div>

                      {this.state.employers.map((input, index) => {
                        return (
                          <div
                            className="row add-card"
                            key={index}
                            style={{ scrollMarginTop: "90px" }}
                          >
                            {index > 0 ? (
                              <div className="col-12">
                                {/* <button
                                  type="button"
                                  className="close"
                                  aria-label="Close"
                                  onClick={() => this.removeEmployer(index)}
                                >
                                  <span aria-hidden="true">&times;</span>
                                </button> */}

                                <Button
                                  variant="primary"
                                  className="close"
                                  aria-label="Close"
                                  onClick={() => this.removeEmployer(index)}
                                >
                                  <span aria-hidden="true">&times;</span>
                                </Button>
                              </div>
                            ) : null}
                            <div className="col-12">
                              <label className="text-black-50 mb-0" htmlFor=" ">
                                {index > 0
                                  ? `Employer *`
                                  : `Current/most recent employer *`}
                              </label>
                              <div className="form">
                                <input
                                  type="text"
                                  name="employer"
                                  id="employer"
                                  className="form-control pl-0"
                                  value={input.employer || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.employers,
                                    )
                                  }
                                  required
                                />

                                {errors.employers[index].employer.length >
                                  0 && (
                                  <span className="error">
                                    {errors.employers[index].employer}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-label-group">
                                <input
                                  type="text"
                                  name="location"
                                  id="location"
                                  className="form-control"
                                  placeholder="Location"
                                  value={input.location || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.employers,
                                    )
                                  }
                                />
                                <label htmlFor=" ">Location</label>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-label-group">
                                <input
                                  type="text"
                                  name="telephone"
                                  id="telephone"
                                  className="form-control"
                                  placeholder="Telephone"
                                  value={input.telephone || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.employers,
                                    )
                                  }
                                />
                                <label htmlFor=" ">Telephone</label>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-label-group">
                                <input
                                  type="email"
                                  name="email"
                                  id="email"
                                  className="form-control"
                                  placeholder="Email"
                                  value={input.email || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.employers,
                                    )
                                  }
                                />
                                <label className="text-xs" htmlFor=" ">
                                  Email Address
                                </label>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-label-group">
                                <input
                                  type="text"
                                  name="industry_type"
                                  id="industry_type"
                                  className="form-control"
                                  placeholder="Industry Type"
                                  value={input.industry_type || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.employers,
                                    )
                                  }
                                />
                                <label className="text-xs" htmlFor=" ">
                                  Primary type of business/industry
                                </label>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-label-group">
                                <input
                                  type="text"
                                  name="job_title"
                                  id="job_title"
                                  className="form-control"
                                  placeholder="Job Title"
                                  value={input.job_title || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.employers,
                                    )
                                  }
                                />
                                <label htmlFor=" ">Job Title</label>
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                              <div className="form-label-group">
                                <input
                                  type="date"
                                  name="date_from"
                                  id="date_from"
                                  className="form-control"
                                  placeholder="Date From"
                                  min="1900-01-01"
                                  max="2050-12-31"
                                  value={input.date_from || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.employers,
                                    )
                                  }
                                  onBlur={() =>
                                    this.validateDateFrom(this.state.employers)
                                  }
                                />
                                <label htmlFor=" ">Date From</label>
                                {isValidDateFrom[`date_from${index}`] && (
                                  <span className="error">
                                    {isValidDateFrom[`date_from${index}`]}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                              <div className="form-label-group">
                                <input
                                  type="date"
                                  name="date_to"
                                  id="date_to"
                                  className="form-control"
                                  placeholder="Date To"
                                  min="1900-01-01"
                                  max="2050-12-31"
                                  value={input.date_to || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.employers,
                                    )
                                  }
                                  onBlur={() =>
                                    this.validateDateTo(this.state.employers)
                                  }
                                />
                                <label htmlFor=" ">Date To</label>
                                {isValidDateTo[`date_to${index}`] && (
                                  <span className="error">
                                    {isValidDateTo[`date_to${index}`]}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-label-group">
                                <input
                                  type="text"
                                  name="supervisor_name"
                                  id="supervisor_name"
                                  className="form-control"
                                  placeholder="Supervisor’s Name"
                                  value={input.supervisor_name || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.employers,
                                    )
                                  }
                                />
                                <label htmlFor=" ">Supervisor’s Name</label>
                              </div>
                            </div>
                            <div className="col-12 mb-3">
                              <label
                                htmlFor=" "
                                className="d-block text-black-50"
                              >
                                May we contact?
                              </label>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name={`may_contact${index}`}
                                  id={`may_contact${index}1`}
                                  checked={
                                    input["may_contact" + index.toString()] ===
                                    "true"
                                  }
                                  value={true}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.employers,
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`may_contact${index}1`}
                                >
                                  YES
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name={`may_contact${index}`}
                                  id={`may_contact${index}2`}
                                  checked={
                                    input["may_contact" + index.toString()] ===
                                    "false"
                                  }
                                  value={false}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.employers,
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`may_contact${index}2`}
                                >
                                  NO
                                </label>
                              </div>
                            </div>
                            <div className="col-12">
                              <label htmlFor=" " className="text-black-50">
                                Describe duties:
                              </label>
                              <div className="form-label-group">
                                <textarea
                                  className="form-control"
                                  name="duties_description"
                                  id="duties_description"
                                  rows="3"
                                  maxLength={1000}
                                  value={input.duties_description}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.employers,
                                    )
                                  }
                                ></textarea>
                              </div>
                            </div>
                            <div className="col-12">
                              <label className="text-black-50" htmlFor=" ">
                                Reason for leaving or wanting to leave:
                              </label>
                              <div className="form-label-group">
                                <textarea
                                  className="form-control"
                                  name="reason_for_leaving"
                                  id="reason_for_leaving"
                                  rows="3"
                                  maxLength={1000}
                                  value={input.reason_for_leaving || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.employers,
                                    )
                                  }
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        );
                      })}

                      {this.state.employers.length <= 4 ? (
                        <div className="row">
                          <div className="col-12 mb-3">
                            {/* <button
                              className="btn btn-outline-secondary btn-xl d-block d-md-inline-block"
                              onClick={this.addMoreEmployer}
                            >
                              + Add Another Employer
                            </button> */}

                            <Button
                              variant="outline-secondary"
                              className="d-block d-md-inline-block"
                              onClick={this.addMoreEmployer}
                            >
                              + Add Another Employer
                            </Button>
                          </div>
                        </div>
                      ) : null}
                    </form>

                    <hr className="my-5" />

                    {/* References */}
                    <form className="form-custom">
                      <div className="row">
                        <div className="col-12">
                          <h5 className="text-black-50 font-weight-bold">
                            References
                          </h5>
                          <p className="text-left">
                            Please provide professional references who have
                            directly supervised your work.
                          </p>
                        </div>
                      </div>
                      {this.state.references.map((reference, index) => {
                        return (
                          <div
                            className="row add-card"
                            key={index}
                            style={{ scrollMarginTop: "90px" }}
                          >
                            {index > 0 ? (
                              <div className="col-12">
                                {/* <button
                                  type="button"
                                  className="close"
                                  aria-label="Close"
                                  onClick={() => this.removeReference(index)}
                                >
                                  <span aria-hidden="true">&times;</span>
                                </button> */}

                                <Button
                                  variant="primary"
                                  className="close"
                                  aria-label="Close"
                                  onClick={() => this.removeReference(index)}
                                >
                                  <span aria-hidden="true">&times;</span>
                                </Button>
                              </div>
                            ) : null}
                            <div className="col-12">
                              <div className="form-label-group">
                                <input
                                  type="text"
                                  name="name"
                                  id="name"
                                  className="form-control"
                                  placeholder="Reference Names"
                                  value={reference.name || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.references,
                                    )
                                  }
                                />
                                <label htmlFor=" ">Reference Name</label>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-label-group">
                                <input
                                  type="text"
                                  name="organization"
                                  id="organization"
                                  className="form-control"
                                  placeholder="Reference Organization"
                                  value={reference.organization || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.references,
                                    )
                                  }
                                />
                                <label htmlFor=" ">
                                  Reference Organization
                                </label>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-label-group">
                                <input
                                  type="text"
                                  name="telephone"
                                  id="telephone"
                                  className="form-control"
                                  placeholder="Reference telephone"
                                  value={reference.telephone || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.references,
                                    )
                                  }
                                />
                                <label htmlFor=" ">Reference Telephone</label>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-label-group">
                                <input
                                  type="text"
                                  name="email_address"
                                  id="email_address"
                                  className="form-control"
                                  placeholder="Reference Email Address"
                                  value={reference.email_address || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.references,
                                    )
                                  }
                                  required
                                />
                                <label className="text-xs" htmlFor=" ">
                                  Reference Email Address *
                                </label>
                                {errors.references[index].email_address.length >
                                  0 && (
                                  <span className="error">
                                    {errors.references[index].email_address}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="form-group">
                                <label
                                  htmlFor="reference_type"
                                  className="text-black-50"
                                >
                                  Type of Reference
                                </label>
                                <select
                                  className="form-control"
                                  name="reference_type"
                                  id="reference_type"
                                  value={reference.reference_type || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.references,
                                    )
                                  }
                                >
                                  <option value="" disabled hidden>
                                    Select
                                  </option>
                                  <option value="supervisor">Supervisor</option>
                                  <option value="peer">Peer</option>
                                  <option value="personal_reference">
                                    Personal Reference
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {this.state.references.length <= 2 ? (
                        <div className="row">
                          <div className="col-12 mb-3">
                            {/* <button
                              className="btn btn-outline-secondary btn-xl d-block d-md-inline-block"
                              onClick={(e) => this.addMoreReference(e)}
                            >
                              + Add Another Reference
                            </button> */}

                            <Button
                              variant="outline-secondary"
                              className="d-block d-md-inline-block"
                              onClick={(e) => this.addMoreReference(e)}
                            >
                              + Add Another Reference
                            </Button>
                          </div>
                        </div>
                      ) : null}
                    </form>

                    <hr className="my-5" />

                    {/* Languages & Skills */}
                    <form className="form-custom">
                      <div className="row">
                        <div className="col-12">
                          <h5 className="text-black-50 font-weight-bold">
                            Comments or Additional Information
                          </h5>
                          <p className="text-left">
                            EXPLAIN ANY GAPS IN EMPLOYMENT. List any
                            professional, trade, business, or civic activities
                            and offices held. You may exclude memberships that
                            would reveal gender, race, religion, national
                            origin, ancestry, age, disability, or any other
                            protected status.
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-label-group">
                            <textarea
                              className="form-control"
                              name="additional_information"
                              id="additional_information"
                              rows="3"
                              placeholder="Type Here"
                              value={this.state.additional_information}
                              onChange={this.handleInputChange}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12 mb-3">
                          <h5 className="text-black-50 font-weight-bold">
                            Languages & Skills:
                          </h5>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label
                              htmlFor="engSkills"
                              className="text-black-50 font-weight-bold"
                            >
                              English
                            </label>
                            <select
                              className="form-control"
                              name="english_skill"
                              id="english_skill"
                              onChange={this.handleInputChange}
                              value={this.state.english_skill}
                            >
                              <option value="" disabled hidden>
                                Select
                              </option>
                              <option value="fluent">Fluent</option>
                              <option value="good">Good</option>
                              <option value="fair">Fair</option>
                              <option value="basic">Basic</option>
                              <option value="none">None</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-6 mb-3">
                          <div className="form-group">
                            <label
                              htmlFor="spaSkills"
                              className="text-black-50 font-weight-bold"
                            >
                              Spanish
                            </label>
                            <select
                              className="form-control"
                              name="spanish_skill"
                              id="spanish_skill"
                              onChange={this.handleInputChange}
                              value={this.state.spanish_skill}
                            >
                              <option value="" disabled hidden>
                                Select
                              </option>
                              <option value="fluent">Fluent</option>
                              <option value="good">Good</option>
                              <option value="fair">Fair</option>
                              <option value="basic">Basic</option>
                              <option value="none">None</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <p className="text-left">
                            Identify skills or certifications you possess
                            related to this position.
                          </p>
                        </div>
                      </div>

                      {this.state.skills_certifications.map((skill, index) => {
                        return (
                          <div
                            className="row add-card"
                            key={index}
                            style={{ scrollMarginTop: "90px" }}
                          >
                            {index > 0 ? (
                              <div className="col-12">
                                {/* <button
                                  type="button"
                                  className="close"
                                  aria-label="Close"
                                  onClick={() =>
                                    this.removeSkillCertification(index)
                                  }
                                >
                                  <span aria-hidden="true">&times;</span>
                                </button> */}

                                <Button
                                  variant="primary"
                                  className="close"
                                  aria-label="Close"
                                  onClick={() =>
                                    this.removeSkillCertification(index)
                                  }
                                >
                                  <span aria-hidden="true">&times;</span>
                                </Button>
                              </div>
                            ) : null}
                            <div className="col-lg-6">
                              <div className="form-label-group">
                                <input
                                  type="text"
                                  name="title"
                                  id="title"
                                  className="form-control"
                                  placeholder="Skill or Certification 1"
                                  value={skill.title}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.skills_certifications,
                                    )
                                  }
                                />
                                <label htmlFor=" ">
                                  Skill or Certification
                                </label>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-label-group">
                                <input
                                  type="text"
                                  name="number_years_experience"
                                  id="number_years_experience"
                                  className="form-control"
                                  placeholder="Years of Experience"
                                  value={skill.number_years_experience || ""}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.skills_certifications,
                                    )
                                  }
                                />
                                <label htmlFor=" ">Years of Experience</label>
                              </div>
                            </div>

                            <div className="col-lg-6">
                              <div className="form-group">
                                <label
                                  htmlFor="abilityLevel"
                                  className="text-black-50 font-weight-bold"
                                >
                                  Ability Level
                                </label>
                                <select
                                  className="form-control"
                                  name="ability_level"
                                  id="ability_level"
                                  value={skill.ability_level}
                                  onChange={(event) =>
                                    this.handleMultipleFieldChange(
                                      event,
                                      index,
                                      this.state.skills_certifications,
                                    )
                                  }
                                >
                                  <option value="" disabled hidden>
                                    Select
                                  </option>
                                  <option value="expert">Expert </option>
                                  <option value="excellent">Excellent</option>
                                  <option value="good">Good</option>
                                  <option value="fair">Fair</option>
                                  <option value="poor">Poor</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {this.state.skills_certifications.length <= 2 ? (
                        <div className="row">
                          <div className="col-12 mb-3">
                            {/* <button
                              className="btn btn-outline-secondary btn-xl d-block d-md-inline-block"
                              style={{ whiteSpace: "normal" }}
                              onClick={(e) => this.addMoreSkillCertification(e)}
                            >
                              + Add Another Skill/Certification
                            </button> */}

                            <Button
                              variant="outline-secondary"
                              className="d-block d-md-inline-block"
                              onClick={(e) => this.addMoreSkillCertification(e)}
                            >
                              + Add Another Skill/Certification
                            </Button>
                          </div>
                        </div>
                      ) : null}
                    </form>

                    <div className="button-wrap my-5">
                      {/* <button
                        onClick={this.saveJobApplicationForm1}
                        className="btn btn-main btn-global d-block d-lg-inline-block"
                      >
                        <Translate value="save_and_continue" />
                      </button> */}

                      <Button
                        variant="primary"
                        className="d-block d-md-inline-block"
                        onClick={this.saveJobApplicationForm1}
                      >
                        <Translate value="save_and_continue" />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  instruction: state.assessment.exams[state.assessment.exam_index].instruction,
  is_ptsd: state.assessment.exams[state.assessment.exam_index].is_ptsd,
  full_name: state.assessment.first_name + " " + state.assessment.last_name,
  email_address: state.assessment.email_address,
  job_applying: state.assessment.job_applying,
});

const mapDispatchToProps = (dispatch) => ({
  show_job_application_form2: () =>
    dispatch(changeView("job_application_form2")),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(JobApplicationForm1);
